import { Button, NavBar, darkTheme } from 'hfs-common-ui';
import uptimeLogoDark from 'images/logos/uptime-logo-dark.svg';
import uptimeLogoLight from 'images/logos/uptime-logo-light.svg';
import { useTheme } from 'styled-components';
import { useDropdownMenuClick } from 'core/hooks/use-dropdown-menu-click';
import { useTranslationWrapper } from 'core/hooks/use-translation-wrapper';
import useMediaQuery from 'core/hooks/use-media-query';
import { InternationalizationNameSpace } from 'core/models/internationalization-namespace';
import { device } from 'core/styles/variables';
import { RoutePaths } from 'core/models';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChangelogReadCount } from 'feature/changelog/hooks/use-changelog-read-count';
import FeedbackLink from 'core/components/FeedbackLink';
import NavMenu from '../NavMenu/NavMenu';
import * as S from './styled';
import MenuWithDropdown from '../MenuWithDropdown';
import { automationIds, testIds } from 'core/test-ids';

const Header = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(device.lg);
  const { t } = useTranslationWrapper(InternationalizationNameSpace.Core);
  const { unreadChangelogIndicator } = useChangelogReadCount();
  const { dropdownMenu, dropdownRef, displayDropdownMenu } = useDropdownMenuClick();

  const logo = {
    src: theme === darkTheme ? uptimeLogoDark : uptimeLogoLight,
    alt: t('CORE:logo.logoDesc'),
    height: 50,
    width: 180,
    style: { paddingBottom: '0.4rem' },
  };
  const logoMobile = {
    src: theme === darkTheme ? uptimeLogoDark : uptimeLogoLight,
    alt: t('CORE:logo.logoDesc'),
    height: 50,
    width: 150,
    style: { maxWidth: '95%' },
  };
  const userSettingsOnClickHanlder = useCallback(() => {
    navigate(RoutePaths.UserInfo);
  }, [navigate]);

  if (!isDesktop) {
    return null;
  }

  return (
    <NavBar
      rightSideArea={
        <S.RightSideAreaDiv ref={dropdownRef}>
          <>
            <S.DropdownContainerDiv id={automationIds.utcInfoIcon}>
              {unreadChangelogIndicator && (
                <S.ChangelogIndicator data-testid={testIds.core.header.changelogIndicator} />
              )}
              <Button
                variant="transparent"
                size="small"
                onClick={displayDropdownMenu}
                icon={{ type: dropdownMenu ? 'notification.info' : 'notification.info_outlined', position: 'left' }}
              />
            </S.DropdownContainerDiv>
            {dropdownMenu && (
              <S.DropdownDiv data-testid={testIds.core.header.dropdown}>
                <MenuWithDropdown isOpen={dropdownMenu} onClick={displayDropdownMenu} />
              </S.DropdownDiv>
            )}
          </>
          <div id={automationIds.utcAvatar}>
            <Button
              variant="transparent"
              size="small"
              onClick={userSettingsOnClickHanlder}
              icon={{ type: 'action.avatar_outlined', position: 'left' }}
            />
          </div>
          <FeedbackLink />
        </S.RightSideAreaDiv>
      }
      logoLink={RoutePaths.Dashboard}
      primaryArea={isDesktop && <NavMenu />}
      desktopLogo={logo}
      mobileLogo={logoMobile}
    />
  );
};
export default Header;
